<template>
    <div>
        <div class="row">
            <template v-for="(size, index) in getSectionRange">
                <div :class="'col-lg-' + (12 / sectionSize)  + ' col-md-' + (12 / sectionSize)">
                    <ul v-for="attribute in getAttributesForSection(index)">
                        <li>
                            <span>{{ attribute['name'] }}: </span>
                            <span v-for="(value, vIndex) in attribute['values']">
                            <i><b>
                                <span v-if="vIndex>0">, </span>
                                <span :class="getCssClassForSelectedAttr(attribute['id'], value['id'], value['value'])">{{ value['value'] }}</span>
                            </b></i>
                        </span>
                        </li>
                    </ul>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default
    {
        props: {
            attributes: {
                Type: Array,
                Default: []
            },
            attributesSelected: {
                Type: Array,
                Default: []
            },
            sectionSize: {
                Type: Number,
                default: 3
            }
        },
        components: {},
        computed: {
            getSectionRange() {
                return new Array(this.sectionSize);
            },
        },
        data() {
            return {
            };
        },
        mounted() {
        },
        methods: {
            getAttributesForSection(index) {
                return this.attributes.filter((v, i) => {
                    let modulo = i % this.sectionSize;

                    return modulo === index;
                });
            },
            getCssClassForSelectedAttr: function(attrId, vId, v) {
                let index = this.attributesSelected.findIndex((attr) => {
                    return attr.id === attrId;
                });

                if (index === -1) {
                    return {};
                }

                let attribute = this.attributesSelected[index];

                switch (attribute.type) {
                    case 2:
                        if (attribute.options) {
                            return {
                                highlight: attribute.value.filter((value) => {
                                    if (null === value.max && value.min <= parseFloat(v)) {
                                        return true;
                                    }

                                    if (value.max >= parseFloat(v) && null === value.min) {
                                        return true;
                                    }

                                    if (value.max >= parseFloat(v) && value.min <= parseFloat(v)) {
                                        return true;
                                    }
                                    return false;
                                }).length > 0
                            };
                        }
                        return {
                            highlight: attribute.values.filter((value) => {
                                if (value.value >= attribute.value[0] && value.value <= attribute.value[1]) {
                                    return value.id === vId;
                                }
                                return false;
                            }).length > 0
                        };
                    case 3:
                        return {
                            highlight: (attribute.value && vId === attribute.checked) || (!attribute.value && vId === attribute.unchecked)
                        };
                    default:
                        return {
                            highlight: attribute.value.filter((value) => {
                                return value.id === vId;
                            }).length > 0
                        };
                }
            }
        }
    }
</script>

<style lang="sass">
    @import "src/assets/scss/variable.scss";
    .highlight {
        color: $main-background-color;
        font-size: 110%;
    }
</style>


// WEBPACK FOOTER //
// attributes.vue?a113ff5c